<div class="sidebar-container">
  <!-- Header/Logo -->
  <div class="sidebar-header">
    <img src="/vessel-icon.png" alt="CuanOne" class="logo-icon" />
    <div class="logo-text">CuanOne</div>
  </div>

  <!-- Navigation Items -->
  <nav class="navigation-section">
    <a
      class="nav-item"
      [class.active]="isRouteActive('/dashboard')"
      routerLink="/dashboard"
      routerLinkActive="active"
    >
      <i-lucide [name]="Ship" [size]="20"></i-lucide>
      <span>Dashboard</span>
    </a>
    <a
      *ngIf="!portalContext.isBoatClub"
      class="nav-item"
      [class.active]="isRouteActive('/request-launch')"
      routerLink="/request-launch"
      routerLinkActive="active"
    >
      <i-lucide [name]="ClipboardList" [size]="20"></i-lucide>
      <span>Request Launch</span>
    </a>
    <a
      *ngIf="!portalContext.isDockhand && !portalContext.isBoatClub"
      class="nav-item"
      [class.active]="isRouteActive('/billing')"
      routerLink="/billing"
      routerLinkActive="active"
    >
      <i-lucide [name]="CreditCard" [size]="20"></i-lucide>
      <span>Billing</span>
    </a>
    <a
      class="nav-item"
      [class.active]="isRouteActive('/account-security')"
      routerLink="/account-security"
      routerLinkActive="active"
    >
      <i-lucide [name]="Settings" [size]="20"></i-lucide>
      <span>Settings</span>
    </a>
    <a
      class="nav-item"
      [class.active]="isRouteActive('/profile')"
      routerLink="/profile"
      routerLinkActive="active"
    >
      <i-lucide [name]="User" [size]="20"></i-lucide>
      <span>Profile</span>
    </a>
  </nav>

  <!-- Footer -->
  <div class="sidebar-footer">
    <div class="version">{{ version }}</div>
  </div>
</div>

